import React, { Component } from 'react'
import { post, get } from '../../utils/networking'
import Footer from '../footer'
import Header from '../header'
import './style.css'
import $ from 'jquery'
import { Calendar } from 'react-date-range';
import { configs } from '../../helpers/constants';
import moment, { now } from 'moment'
import { Route, NavLink, HashRouter, Router } from "react-router-dom";
import { concatStatic } from 'rxjs/operator/concat';

export default class Appointment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            appointmentList: [],
            hours: 0,
            minutes: 0,
            isAM: true,
            isShowPopup: 0,
            isLoaded: false,
            isShowConfirm: false,
            isProsessing: false,
            date: "",
            isSuccessChange: false,
            notifyMessage: "",
            currentAppoitment: null,
            isShowDetailAppointment: false,
            defaultStoreSlug: ""
        }
    }

    parseDate(input, format) {
        format = format || 'yyyy-mm-dd'; // default format
        var parts = input.match(/(\d+)/g),
            i = 0, fmt = {};
        // extract date-part indexes from the format
        format.replace(/(yyyy|dd|mm)/g, function (part) { fmt[part] = i++; });

        return new Date(parts[fmt['yyyy']], parts[fmt['mm']] - 1, parts[fmt['dd']]);
    }

    componentDidMount() {
        get("appointment/history/full", "customer", result => {
            this.setState({
                appointmentList: result,
                isLoaded: true
            }, () => {
                get('store/get', "customer", result => {
                    this.setState({
                        defaultStoreSlug: result[0].slug,
                    })
                })
            })
        })
    }

    getDayInWeek(date) {
        var d = moment(date);
        return d.isoWeekday();
    }

    onSelectDate(value) {
        this.setState({
            date: (value) ? value.format("dddd, DD MM YYYY").toString() : ""
        });
    }
    onTimeChange(target, action) {
        let {
            hours,
            minutes,
            isAM
        } = this.state;
        if (target === "h") {
            if (action === "up") {
                (hours < 12) ? (hours++) : 12;
            }
            else {
                (hours > 1) ? (hours--) : 1;
            }
        }
        if (target === "m") {
            if (action === "up") {
                if (minutes < 50) {
                    minutes += 10
                } else {
                    minutes = 0;
                    hours = hours < 12 ? ++hours : 1
                }
            }
            else {
                (minutes > 0) ? (minutes -= 10) : 0;
            }
        }
        if (target === "p") {
            if (action === "up") {
                isAM = true;
            }
            else {
                isAM = false;
            }
        }
        this.setState({
            hours: hours,
            minutes: (minutes > 59) ? 59 : (minutes < 0) ? 0 : minutes,
            isAM: isAM
        })
    }
    onInputTime(e, target) {
        let {
            hours,
            minutes
        } = this.state;
        if (target === "h") {
            hours = (parseInt(e.target.value) < 0 || isNaN(parseInt(e.target.value))) ? 0 : (parseInt(e.target.value) > 12) ? 12 : parseInt(e.target.value)
        }
        if (target === "m") {
            minutes = (parseInt(e.target.value) < 0 || isNaN(parseInt(e.target.value))) ? 0 : (parseInt(e.target.value) > 59) ? 59 : parseInt(e.target.value)
        }
        this.setState({
            hours: hours,
            minutes: minutes
        })
    }

    onInitSchedule(value) {
        this.setState({
            hours: parseFloat(moment(value).format("hh")),
            minutes: parseFloat(moment(value).format("mm")),
            isAM: moment(value).hours() <= 12
        })
    }
    handleCancel(id) {
        this.setState({
            isProsessing: true
        })
        post("/appointment/book/delete/" + id, {}, 'customer', result => {
            get("appointment/history/full", "customer", result => {
                this.setState({
                    appointmentList: result,
                    isShowConfirm: false,
                    isProsessing: false,
                    isSuccessChange: true,
                    notifyMessage: "You canceled the appointment successfully."
                })
            })
        })
        setTimeout(() => {
            this.setState({
                isSuccessChange: false
            })
        }, 10000);
    }

    handleChange(id) {
        this.setState({
            isProsessing: true
        })
        var newDate = moment(moment(this.state.date, "DD MM YYYY").format("DD/MM/YYYY") + " " + this.state.hours + ":" + this.state.minutes + " " + ((this.state.isAM) ? "AM" : "PM"), "DD/MM/YYYY HH:mm a").toDate();
        let param = {
            id: id,
            date: newDate
        }
        post("/appointment/book/update", param, 'customer', result => {
            get("appointment/history/full", "customer", result => {
                this.setState({
                    appointmentList: result,
                    isShowPopup: false,
                    isProsessing: false,
                    isSuccessChange: true,
                    notifyMessage: "Your appointment have been changed successfully"
                })
            })
        })
        setTimeout(() => {
            this.setState({
                isSuccessChange: false
            })
        }, 10000);
    }


    viewAppointmentDetail(item) {
        this.setState({
            currentAppoitment: item
        }, () => {
            this.setState({
                isShowDetailAppointment: true
            })
        })
    }

    render() {

        let {
            appointmentList,
            hours,
            minutes,
            isAM,
            isShowPopup,
            isLoaded,
            isShowConfirm,
            isProsessing,
            isSuccessChange,
            notifyMessage,
            currentAppoitment,
            isShowDetailAppointment,
            defaultStoreSlug
        } = this.state;


        return (
            <div id="appointment_list" >
                {
                    (appointmentList != null) ? <div className="list_contain">
                        <label className="list_title">Your appointment <span className="bt-book-now"><span onClick={() => {
                            this.props.history.push("/spa/" + defaultStoreSlug + "?tab=3")
                        }}>Book Appointment Now</span></span></label>
                        {
                            (isSuccessChange) ? <p className="appointment_list_notify">{notifyMessage}</p> : ""
                        }
                        {
                            (isLoaded) ? <div className="list_detail">
                                {
                                    appointmentList.map((item, i) => {

                                        if (/Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor))
                                            item.bookingDate = new Date(item.bookingDate)
                                        else
                                            item.bookingDate = moment.utc(item.bookingDate).toLocaleString()


                                        return (
                                            <div className="appointment_item" key={i} style={{ backgroundImage: "linear-gradient(rgba(255, 255, 255, 0.95),rgba(255, 255,255, 0.95)),url(https://www.mackaytourism.org/images/organisation/73822/f7UnO5Sr6ra_Mf_1920x1279.jpg)" }}>
                                                <div className="header">
                                                    <div className="id_and_date">
                                                        <span className="id">ID: {item.id}</span>
                                                        <span className="date">{moment(item.bookingDate).format("MM/DD/YYYY hh:mm a")}</span>
                                                    </div>
                                                    <div className="day_in_week">
                                                        <table>
                                                            <tbody>
                                                                <tr>
                                                                    <td className={(this.getDayInWeek(item.bookingDate) === 1) ? "active" : ""}>Mon</td>
                                                                    <td className={(this.getDayInWeek(item.bookingDate) === 2) ? "active" : ""}>Tues</td>
                                                                    <td className={(this.getDayInWeek(item.bookingDate) === 3) ? "active" : ""}>Wed</td>
                                                                    <td className={(this.getDayInWeek(item.bookingDate) === 4) ? "active" : ""}>Thurs</td>
                                                                    <td className={(this.getDayInWeek(item.bookingDate) === 5) ? "active" : ""}>Fri</td>
                                                                    <td className={(this.getDayInWeek(item.bookingDate) === 6) ? "active" : ""}>Sat</td>
                                                                    <td className={(this.getDayInWeek(item.bookingDate) === 7) ? "active" : ""}>Sun</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div className="service_name">
                                                        {
                                                            (item.items.length === 1) ? <span >Service: {item.items[0].serviceName}</span> :
                                                                <span> Service: you have {item.items.length} services in this apointment<p style={{ padding: "2px 0px 3px 0px", textAlign: "right", color: "blue" }} onClick={() => this.viewAppointmentDetail(item)}>Click for detail</p></span>
                                                        }
                                                        {
                                                            (item.items.length === 1) ? <span >Staff: {item.items[0].staffName}</span> : ""
                                                        }
                                                        <span className="spa_name">Spa: {item.storeName}</span>
                                                        <span className="spa_address">Address: {item.storeAddress}</span>
                                                        <span className="price">Price: ${item.total}</span>
                                                        < div className="service_detail">
                                                        </div>

                                                    </div>
                                                </div>
                                                <div className="footer">
                                                    <span className="bt_change" onClick={() => {
                                                        this.setState({ isShowPopup: item.id })
                                                        this.onInitSchedule(item.bookingDate)
                                                    }
                                                    }>Re-schedule</span>
                                                    <span className="bt_cancel" onClick={() => this.setState({ isShowConfirm: item.id })}>Cancel</span>
                                                    <div className={(isShowConfirm == item.id) ? "confirm-cancel" : "confirm-cancel hide"}>
                                                        <div className="content">
                                                            <div className="header">
                                                                <span> Cancel this appointment now? </span>
                                                                <i className="fas fa-times" onClick={() => this.setState({ isShowConfirm: false })}></i>
                                                            </div>
                                                            <div className="detail">
                                                                <div className="id_and_date">
                                                                    <span className="id">ID: {item.id}</span>
                                                                    <span className="date">{moment(item.bookingDate).format("MM/DD/YYYY hh:mm a")}</span>
                                                                </div>
                                                                <div className="service_name">
                                                                    <span >Service: {item.items[0].serviceName}</span>
                                                                    <span className="spa_name">Spa: {item.storeName}</span>
                                                                    <span className="spa_address">Address: {item.storeAddress}</span>
                                                                    <span className="price">Price: ${item.total}</span>
                                                                    < div className="service_detail">
                                                                    </div>

                                                                </div>
                                                            </div>
                                                            <div className="submit">
                                                                <span className="submit-save" onClick={() => this.handleCancel(item.id)}>
                                                                    {
                                                                        (isProsessing) ? <i className="fa fa-spinner fa-pulse" style={{ marginRight: "10px" }}> </i> : ""
                                                                    }
                                                                    {(isProsessing) ? "Waiting..." : "Yes"}</span>
                                                                <span className="submit-cancel" onClick={() => this.setState({ isShowConfirm: false })}>No</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={isShowPopup == item.id ? "re-schedule-box" : "re-schedule-box hide"} >
                                                    <div className="content">
                                                        <div className="header">
                                                            <span> Re-Schedule your appointment </span>
                                                            <i className="fas fa-times" onClick={() => this.setState({ isShowPopup: false })}></i>
                                                        </div>
                                                        <div className="detail">
                                                            <div className="date-time">
                                                                <div className="date">
                                                                    <Calendar key={this.state.keyReload}
                                                                        date={moment(item.bookingDate).format("DD/MM/YYYY").toString()}
                                                                        onInit={this.onSelectDate.bind(this)}
                                                                        onChange={this.onSelectDate.bind(this)}
                                                                    />
                                                                </div>
                                                                <div className="time">
                                                                    <table>
                                                                        <tbody>
                                                                            <tr>
                                                                                <td onClick={this.onTimeChange.bind(this, "h", "up")}><i className="fa fa-chevron-up" aria-hidden="true"></i></td>
                                                                                <td>&nbsp;</td>
                                                                                <td onClick={this.onTimeChange.bind(this, "m", "up")}><i className="fa fa-chevron-up" aria-hidden="true"></i></td>
                                                                                <td onClick={this.onTimeChange.bind(this, "p", "up")}><i className="fa fa-chevron-up" aria-hidden="true"></i></td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td><input type="text" value={hours} onChange={(value) => this.onInputTime(value, "h")} /></td>
                                                                                <td>:</td>
                                                                                <td><input type="text" value={minutes} onChange={(value) => this.onInputTime(value, "m")} /></td>
                                                                                <td><input type="text" value={(isAM) ? "AM" : "PM"} readOnly={true} /></td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td onClick={this.onTimeChange.bind(this, "h", "down")}><i className="fa fa-chevron-down" aria-hidden="true"></i></td>
                                                                                <td>&nbsp;</td>
                                                                                <td onClick={this.onTimeChange.bind(this, "m", "down")}><i className="fa fa-chevron-down" aria-hidden="true"></i></td>
                                                                                <td onClick={this.onTimeChange.bind(this, "p", "down")}><i className="fa fa-chevron-down" aria-hidden="true"></i></td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="submit">
                                                            <span className="submit-save" onClick={() => this.handleChange(item.id)}>
                                                                {
                                                                    (isProsessing) ? <i className="fa fa-spinner fa-pulse" style={{ marginRight: "10px" }}> </i> : ""
                                                                }
                                                                {(isProsessing) ? "Waiting..." : "Save your change"}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div> : <div>
                                    <div className="spinner">
                                        <div className="rect1"></div>
                                        <div className="rect2"></div>
                                        <div className="rect3"></div>
                                        <div className="rect4"></div>
                                        <div className="rect5"></div>
                                    </div>
                                </div>
                        }
                    </div> : <h1>Empty</h1>
                }
                {
                    (isShowDetailAppointment) ? <div className="view-box-detail">
                        <div className="content">
                            <div className="header">
                                <span className="title">Appointment</span>
                                <i className="fa fa-times" aria-hidden="true" onClick={() => this.setState({ isShowDetailAppointment: false })}></i>
                            </div>
                            <div className="detail">
                                {
                                    (currentAppoitment) ? currentAppoitment.items.map((item, i) => <div className="service-info-item">
                                        <span>Service {i + 1}: {item.serviceName}</span>
                                        <span>Staff: {item.staffName}</span>
                                        <span>Total: ${item.subtotal}</span>
                                    </div>) : ""
                                }
                            </div>
                        </div>
                    </div> : ""
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/appointmentList/index.js